import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  files: [],
  stepIndex: 0,
  isValidating: false,
  organization: "",
  selectedOrganization: ""
});
const initialFileState = {
  hasValidated: false,
  isUploading: false,
  hasUploaded: false,
  hasTestInserted: false,
  errorsUploading: false,
  submissionID: "",
  errors: [],
  warnings: [],
  debug: [],
  info: [],
  validationLog: [],
  joiErrors: []
};
function uploadReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPLOAD_SET_FILE_IS_UPLOADING:
      return state.setIn(
        ["files", action.payload.fileIndex, "isUploading"],
        action.payload.isUploading
      );
    case types.SET_STEP_INDEX:
      return state.set("stepIndex", action.payload);

    case types.SET_SELECTED_ORGANIZATION:
      return state.set("selectedOrganization", action.payload);

    case types.UPLOAD_ADD_FILES:
      return state.update("files", f =>
        f.concat(
          Immutable.fromJS(
            action.payload.map(file => ({
              ...initialFileState,
              // uploadErrors: [],
              name: file.name,
              file
            }))
          )
        )
      );

    case types.UPLOAD_FILE_UPLOAD_SUCCESS:
      return state.withMutations(s =>
        s
          .mergeIn(["files", action.payload.fileIndex], {
            isUploading: false,
            hasUploaded: !action.payload.isTestInsert,
            hasValidated: true,
            isValidating: false,
            hasTestInserted:
              action.payload.isTestInsert ||
              state.getIn(
                ["files", action.payload.fileIndex],
                "hasTestInserted"
              ),
            errorsUploading: false,
            // uploadErrors: Immutable.fromJS(action.payload.uploadErrors),
            submissionID: action.payload.submissionID
          })
          .updateIn(["files", action.payload.fileIndex, "errors"], log =>
            log.concat(action.payload.errors)
          )
          .updateIn(["files", action.payload.fileIndex, "warnings"], log =>
            log.concat(action.payload.warnings)
          )
      );

    case types.UPLOAD_FILE_UPLOAD_ERROR:
      return state.withMutations(s =>
        s
          .mergeIn(["files", action.meta.fileIndex], {
            // uploadErrors: Immutable.fromJS(action.payload.uploadErrors),
            isUploading: false,
            hasTestInserted: false,
            hasUploaded: false,
            errorsUploading: true
          })
          .updateIn(["files", action.meta.fileIndex, "validationLog"], log =>
            log.push({ level: "error", message: action.payload.message })
          )
      );

    case types.UPDATE_FILE_IS_SET_VALIDATING:
      return state.setIn(
        ["files", action.payload.fileIndex, "isValidating"],
        action.payload.isValidating
      );

    case types.UPLOAD_RESET_FILES:
      return state.merge({
        files: Immutable.fromJS([]),
        stepIndex: 0
      });
    case types.UPLOAD_UPDATE_VALIDATION_LOG:
      return state.updateIn(
        ["files", action.payload.fileIndex, "validationLog"],
        log => log.concat(action.payload.validationLog)
      );
    case types.UPLOAD_UPDATE_FILE_STATUS:
      return state.mergeIn(["files", action.payload.fileIndex], {
        ...initialFileState,
        hasValidated:
          action.payload.hasValidated || initialFileState.hasValidated,
        isValidating: action.payload.isValidating,
        errors: action.payload.errors,
        warnings: action.payload.warnings,
        debug: action.payload.debug,
        debugLog: action.payload.debugLog,
        info: action.payload.info,
        joiErrors: action.payload.joiErrors
        // validationLog: state
        //   .getIn(["files", action.payload.fileIndex, "validationLog"])
        //   .concat(action.payload.validationLog),
      });

    case types.UPLOAD_REMOVE_FILE:
      return state.removeIn(["files", action.payload]);

    default:
      return state;
  }
}

export default uploadReducer;
